import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ExcelWriterService } from '../../services/excel-writer.service';
import Swal from 'sweetalert2';
import { HELPER_NOTES_CONSTANTS } from '../../utils/constants';
import { Project } from '../../models/project';

@Component({
  selector: 'app-action-buttons-panel',
  templateUrl: './action-buttons-panel.component.html',
  styleUrls: ['./action-buttons-panel.component.css']
})
export class ActionButtonsPanelRenderer implements OnInit {

  @Input() addLabel: string = 'Add';
  @Input() customLabel: string = '';
  @Input() isSaving!: boolean;
  @Input() noteToUse: string="";
  @Input() useAddAction: boolean = false;
  @Input() useCustomAction: boolean = false;
  @Input() useHelperNote: boolean=false;
  @Input() useSaveAction: boolean = false;
  @Input() useSelectAll: boolean = false;
  @Input() useServerExcelExportAction: boolean = false;
  @Input() useSignOffAction: boolean = false;
  @Input() selectedProject?: Project;

  @Output() onBtAddEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBtnCustomEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBtnSelectAllClicked = new EventEmitter<any>();
  @Output() onBtSaveEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBtServerExcelExportEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBtnSignOffEvent: EventEmitter<any> = new EventEmitter<any>();

  public isDownloading : boolean = false;
  public eraSmeNotificationDialogVisible: boolean = false;

  private onDownloadCompleteSubscription: Subscription | undefined;

  constructor(private exportService: ExcelWriterService) {}
  ngOnInit() {
    this.onDownloadCompleteSubscription = this.exportService.downloadCompleted.subscribe(() => {
        this.isDownloading = false;
    });
}
  add() {
    this.onBtAddEvent.emit()
  }

  save() {
    this.onBtSaveEvent.emit();
  }

  custom(){
    this.onBtnCustomEvent.emit();
  }

  signOff() {
    this.onBtnSignOffEvent.emit();
  }

  onBtServerExcelExport() {
    this.isDownloading = true;
    this.onBtServerExcelExportEvent.emit();
  }

  onSelectAllClicked(): void {
    this.onBtnSelectAllClicked.emit();
  }

  ngOnDestroy() {
    if (this.onDownloadCompleteSubscription) {
      this.onDownloadCompleteSubscription.unsubscribe();
    }
  }
  showHelperNotesPopup(note:string) {
    Swal.fire({
      title: 'Helper notes',
      html: HELPER_NOTES_CONSTANTS.MESSAGES[note]||"No helper note found",
      icon: 'info',
      width:350
    });
  }

  eraSmeNotificationDialog() : void{
    this.eraSmeNotificationDialogVisible = true;
  }



}
